/**
 * Контракт чата мини-аппа.
 *
 * Комнаты заведены с запасом под группы и лички: сейчас живёт только общий зал
 * со slug `lobby`, но клиент и API уже ходят по идентификатору комнаты, а не
 * по глобальному списку сообщений.
 *
 * История живёт 12 часов. Это не журнал и не доказательство — старые реплики
 * просто исчезают, и клиент не должен пытаться их догрузить.
 */
export const CHAT_LOBBY_SLUG = "lobby";
export const CHAT_RETENTION_MS = 12 * 60 * 60 * 1000;
export const CHAT_MAX_BODY_LENGTH = 280;
export const CHAT_MAX_MESSAGES = 400;
export const CHAT_STICKERS = [
    { id: "wave", emoji: "😺", label: "Привет" },
    { id: "love", emoji: "😻", label: "Люблю" },
    { id: "lol", emoji: "😹", label: "Смеюсь" },
    { id: "cool", emoji: "😼", label: "Круто" },
    { id: "shock", emoji: "🙀", label: "Шок" },
    { id: "sad", emoji: "😿", label: "Грусть" },
    { id: "purr", emoji: "😽", label: "Мур" },
    { id: "paws", emoji: "🐾", label: "Лапки" },
    { id: "yarn", emoji: "🧶", label: "Клубок" },
    { id: "fish", emoji: "🐟", label: "Рыбка" },
    { id: "crown", emoji: "👑", label: "Корона" },
    { id: "milk", emoji: "🥛", label: "Молоко" },
];
export const CHAT_REACTIONS = ["🐾", "😹", "🔥", "❤️"];
export const CHAT_MUTE_MS = {
    "15m": 15 * 60 * 1000,
    "1h": 60 * 60 * 1000,
    "12h": 12 * 60 * 60 * 1000,
};
export const CHAT_SLOW_OPTIONS = [0, 5, 15, 30];
export function formatMuteRemain(untilIso, forever, now = Date.now()) {
    if (forever || untilIso === null)
        return "навсегда";
    const left = Date.parse(untilIso) - now;
    if (!Number.isFinite(left) || left <= 0)
        return "0:00";
    const totalSec = Math.ceil(left / 1000);
    const hours = Math.floor(totalSec / 3600);
    const minutes = Math.floor((totalSec % 3600) / 60);
    const seconds = totalSec % 60;
    if (hours > 0)
        return `${hours}ч ${minutes}м`;
    return `${minutes}:${String(seconds).padStart(2, "0")}`;
}
export const CHAT_ERROR_CODES = {
    Unauthorized: "unauthorized",
    Forbidden: "forbidden",
    NotFound: "not_found",
    Muted: "muted",
    SlowMode: "slow_mode",
    RateLimited: "rate_limited",
    BadMessage: "bad_message",
    Blocked: "blocked",
};
export function chatStickerById(id) {
    return CHAT_STICKERS.find((sticker) => sticker.id === id);
}
export function canModerateChat(role) {
    return role === "admin" || role === "moderator";
}
/** Короткий превью для списка комнат и цитаты. */
export function chatPreview(kind, body) {
    if (kind === "sticker") {
        const sticker = chatStickerById(body);
        return sticker ? sticker.emoji : "🐾";
    }
    const trimmed = body.trim().replace(/\s+/g, " ");
    return trimmed.length > 80 ? `${trimmed.slice(0, 79)}…` : trimmed;
}
/** Какие спецэффекты запускает сообщение или реакция. */
export function chatFxFor(kind, body) {
    if (kind === "sticker" && body === "purr")
        return "purr";
    if (kind === "sticker" && body === "paws")
        return "paws";
    if (body === "🐾")
        return "paws";
    return undefined;
}
//# sourceMappingURL=chat.js.map